<template>
  <div class="toast-address">
    <div
      class="address-item"
      :class="{ coped: isCopy && copyIndex === index }"
      v-for="(address, index) in addressList"
      :key="index"
    >
      <span>{{ address.slice(0, 6) + '...' + address.slice(-6) }}</span>
      <img src="../assets/sol/copy.png" alt="" @click.stop="onCopy(address, index)" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    addressList: {
      type: Array,
    },
  },
  data() {
    return {
      isCopy: false,
      copyIndex: undefined
    }
  },
  methods: {
    onCopy(address, index) {
      if (this.isCopy) {
        return
      }
      this.copyIndex = index
      this.$copyText(address);
      this.isCopy = true
      setTimeout(() => {
        this.isCopy = false
        this.copyIndex = undefined
      }, 1000);
    }
  },
  // mounted() {
  //   console.log('addressList', this.addressList);
  // }
};
</script>

<style lang="scss" scoped>
.toast-address {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.02rem 0;
  .address-item {
    display: flex;
    align-items: center;
    span {
      color: #fff;
      margin-left: 0.08rem;
      font-size: 0.12rem;
    }
    img {
      margin-left: 0.06rem;
      width: 0.14rem;
      height: 0.14rem;
      cursor: pointer;
    }
    &.coped {
      opacity: 0.5;
    }
  }
}

@media screen and (max-width: 767px) {
  .toast-address {
    .address-item {
      span {
        font-size: 0.28rem;
      }
      img {
        width: 0.28rem;
        height: 0.28rem;
      }
    }
  }
}
</style>
